export default __webpack_public_path__ + "static/media/features3.1354bdec.svg";